import { UPLOAD_STALL_TIMEOUT, UploadStatusError, USER_ABORTED_UPLOAD } from '@air/upload';

const HTTP_CLIENT_400_ERROR_MIN = 400;
const HTTP_CLIENT_400_ERROR_MAX = 499;

export const isAbortError = (error: unknown): boolean => {
  if (typeof error === 'object' && error !== null && 'message' in error) {
    return error.message === USER_ABORTED_UPLOAD;
  }

  return false;
};

export const isUploadStallError = (error: unknown): boolean =>
  error instanceof Error && error.message === UPLOAD_STALL_TIMEOUT;

export const isStatus0Error = (error: unknown): boolean => error instanceof UploadStatusError && error.status === 0;

export const is4xxError = (error: unknown): boolean => {
  if (typeof error === 'object' && error !== null && 'status' in error && typeof error.status === 'number') {
    return error.status >= HTTP_CLIENT_400_ERROR_MIN && error.status <= HTTP_CLIENT_400_ERROR_MAX;
  }

  return false;
};

export const isUploadTransferInstabilityError = (error: unknown): boolean => isUploadStallError(error);
